// extracted by mini-css-extract-plugin
export default {"svg":"CreateEvent_svg__vncyR","active":"CreateEvent_active__C1t-Q"};